import React, { useEffect, useState } from "react";
import RegisterOrder from "./RegisterOrder";
import { Button } from "antd";
import classes from "./Register.module.css";
import RegisterOrders from "./RegisterOrders";

const Register = () => {
	const [activeTab, setActiveTab] = useState("register");
	const handleTabClick = (tab: any) => {
		setActiveTab(tab);
	};

	return (
		<div className={classes.mainButtons}>
			<div className={classes.buttonContainer}>
				<Button
					onClick={() => handleTabClick("register")}
					className={
						activeTab === "register"
							? `${classes.active}`
							: `${classes.nonactive}`
					}
				>
					Register
				</Button>
				<Button
					onClick={() => handleTabClick("upload")}
					className={
						activeTab === "upload"
							? `${classes.active}`
							: `${classes.nonactive}`
					}
				>
					Upload
				</Button>
			</div>

			{activeTab === "register" && <RegisterOrder />}
			{activeTab === "upload" && <RegisterOrders />}
		</div>
	);
};

export default Register;
